import { Heading } from "@chakra-ui/react";

export function Index() {
  return <Heading as="h1">Admin Portal</Heading>;
}

export { AvelaAdminRoutes } from "./AvelaAdminRoutes";
export { Layout } from "./Layout";
